import { ApiMetaDataDTO, StatusDTO, SupplierDTO } from 'declarations'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

type ApiResponseDTO = {
  code: number
  data: StatusDTO[]
  api_metadata: ApiMetaDataDTO
}

export const useShipmentStatusListQuery = (): UseQueryResult<
  StatusDTO[],
  unknown
> => {
  return useQuery({
    queryKey: ['shipment', 'status', 'list'],
    queryFn: async () => {
      try {
        const res = await client.get<ApiResponseDTO>('/shipment/status/list')
        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
}
